import { types, actions } from './requests'
export const GETITEMLIST_TYPES = {
    ...types('GETITEMLIST'),
}
export const GETITEMLIST_ACTIONS = {
    ...actions('GETITEMLIST'),
}
